import React, { Component } from "react";
import { Row, Col, Image } from "react-bootstrap";
import GoogleMapsLoader from "google-maps";
import FilterContainer from "./FilterContainer.jsx";
import MemberCard from "./MemberCard.jsx";
import MemberContactModal from "./MemberContactModal.jsx";
import hyperlinks from "../../../src/util/hyperlinks";
import mapStyling from "../../../src/util/mapStyling";
import nameMapping from "../../../src/util/nameMapping";
import axios from "axios";



GoogleMapsLoader.KEY = "AIzaSyCq1CXQbDuMtg1LajNE_1au1W_R3bLScLk";

export default class MembersGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            members: this.props.members,
            expandedCards : [],
            showModal: false,
            searchQuery: ""
        };
        this.updateMembers = this.updateMembers.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
        this.handleInfoWindowButtonClick = this.handleInfoWindowButtonClick.bind(this);
        this.contactButtonClick = this.contactButtonClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.resetExpandedCards = this.resetExpandedCards.bind(this);
        this.handleSearchInput = this.handleSearchInput.bind(this);
    }

    updateMembers(newMembers) {
        this.setState({ members: newMembers });
    }

    resetExpandedCards() {
        this.setState({ expandedCards: [] });
    }

    handleCardClick(e) {
        if (this.props.foundationPartner) return;
        if (this.props.showOverlay) return;
        const member = e.target.closest(".member") || e.target.parentElement.parentElement.querySelector(".member");
        if (member.className.match(/expanded/)) {
            member.className = member.className.replace(/ expanded/, "");
        } else {
            axios.post("/analytics_messages.json", { type: 'expand-card', member_id: member.dataset.cardId });
            member.className += " expanded";
        }

        const currentlyExpandedCards = Array.from(e.target.closest(".members-grid").querySelectorAll("div[data-card-id]"))
            .filter(el => {
                return !!el.className.match(/expanded/);
            })
            .map((el => el.dataset.cardId));
        this.setState({ expandedCards: currentlyExpandedCards });
    }

    handleInfoWindowButtonClick(e) {
        const selectedMember = this.state.members.find(member => member.id == e.target.dataset.id);
        const reorderedMembers = Object.assign([], this.state.members);
        reorderedMembers.unshift(reorderedMembers.splice(reorderedMembers.indexOf(selectedMember), 1)[0]);
        this.setState({
            expandedCards: [e.target.dataset.id.toString()],
            members: reorderedMembers
        });
        this.props.updateParentState({ showOnMap: false });
    }

    contactButtonClick(e) {
        const memberId = e.target.parentElement.querySelector(".member").dataset.cardId;
        if (this.props.currentUser) {
            // Opens e-mail
            // const member = this.state.members.find(member => member.id == e.target.parentElement.querySelector(".member").dataset.cardId);
            // location.href = `mailto:${member.primary_contact.email}`;

            // Redirects to messaging app
            axios.post("/analytics_messages.json", { type: 'contact-card-click', member_id: memberId, current_user_id: this.props.currentUser.id });
            location.href = "/users/messages";
        } else {
            axios.post("/analytics_messages.json", { type: 'contact-card-click', member_id: memberId, current_user_id: null });
            this.setState({ showModal: true });
        }
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    componentDidUpdate() {
        if (this.props.showOnMap) {
            GoogleMapsLoader.load((google) => {
                // Gross and hacky, but google has to be accessible as a variable
                const InfoBox = require("google-maps-infobox");
                const styledMap = new google.maps.StyledMapType(mapStyling);
                const map = new google.maps.Map(document.getElementById("map"), {
                    zoom: 2,
                    minZoom: 2,
                    maxZoom: 6,
                    center: {lat: 43, lng: 10},
                    disableDefaultUI: true,
                    zoomControl: true
                });
                const infoWindow = new InfoBox({
                    alignBottom: true,
                    pixelOffset: new google.maps.Size(-100, -50),
                    closeBoxURL: "/assets/dark-blue-close-button-baceb7231049567e50520d1b5c368c8baa6c4169be3a53c74189702d4c43b234.png"
                });
                this.state.members.forEach(member => {
                    const icon = member.advisory_board ? "/assets/light-blue-pin-105819b2a92c94eceaeba91d40250cec30461aa39c815145d2f41e5eb3ceb5aa.png" : "/assets/dark-blue-pin-690a31d0d00f30b670c7d9d43a18e05e506272abb82a217df61f75c659aa2456.png";
                    const marker = new google.maps.Marker({
                        position: { lat: member.lat, lng: member.lng },
                        map: map,
                        title: nameMapping[member.short_name] || member.short_name,
                        icon: icon
                    });

                    // Set info window content
                    const infoWindowContent = document.createElement("DIV");
                    infoWindowContent.className = `info-window${member.advisory_board ? " advisory-board" : ""}`;
                    if (member.advisory_board) {
                        const topLabel = document.createElement("div");
                        topLabel.className = "top-label";
                        topLabel.innerText = "Advisory Board";
                        infoWindowContent.appendChild(topLabel);
                    }
                    const img = document.createElement("IMG");
                    img.setAttribute("src", member.fingerprinted_logo);
                    const button = document.createElement("BUTTON");
                    button.type = "button";
                    button.innerText = "Learn More";
                    button.dataset.id = member.id;
                    button.addEventListener("click", this.handleInfoWindowButtonClick);
                    infoWindowContent.appendChild(img);
                    infoWindowContent.appendChild(button);

                    marker.addListener("click", () => {
                        infoWindow.setContent(infoWindowContent);
                        infoWindow.open(map, marker);
                    });
                });
                map.mapTypes.set("styled_map", styledMap);
                map.setMapTypeId("styled_map");
            });
        }
    }

    handleSearchInput(e) {
        if (e === "") {
            this.setState({
                searchQuery: e
            })
        }  else {
            const { members } = this.props;
            const searchQuery = e.currentTarget.value;
            const filteredMembers = members.filter(member => member.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1)
            this.setState({
                members: filteredMembers,
                searchQuery,
            });
        }
    }

    render() {
        const members = this.state.members.slice(0, this.props.limit).map((member, i) => {
            return <MemberCard
                member={member}
                filterGroup={this.props.filterGroup}
                filterGroups={this.props.filterGroups}
                innovationAreasFor={this.props.innovationAreasFor}
                showNames={this.props.showNames}
                cardId={member.id}
                expanded={this.props.foundationPartner || this.state.expandedCards.includes(String(member.id))}
                handleClick={this.handleCardClick}
                contactButtonClick={this.contactButtonClick}
                currentUser={this.props.currentUser}
                key={`member${i + 1}`}
            />;
        });

        const rows = [];

        for (var i = 0; i < (this.props.limit || this.state.members.length) / 3; i++) {
            let rowContent = (
                <Row key={`membersGridRow${i + 1}`}>
                    {members.slice(i * 3, i * 3 + 3)}
                </Row>
            );
            rows.push(rowContent);
            if (i == 0 && this.props.showOverlay) {
                let overlay = (
                    <a key="membersGridOverlay" href={hyperlinks["currentMembers"]}>
                        <div className="bar">
                            Meet All Our Members
                        </div>
                    </a>
                );
                rows.push(overlay);
            }
        }

        let filterBar;
        if (!this.props.foundationPartner && this.props.showNames) {
            filterBar = <FilterContainer
                group={this.props.filterGroup}
                innovationAreas={this.props.innovationAreas}
                updateMembers={this.updateMembers}
                activeFilters={this.props.activeFilters}
                resetExpandedCards={this.resetExpandedCards}
                countries={this.props.membersByCountry}
                handleSearchInput={this.handleSearchInput}
                searchQuery={this.state.searchQuery}
            />;
        }

        if (this.props.showOnMap) {
            return (
                <div className="members-map">
                    {filterBar}
                    <div id="map"></div>
                </div>
            );
        } else {
            return (
                <div className="members-grid">
                    {filterBar}
                    {rows}
                    <MemberContactModal showModal={this.state.showModal} closeModal={this.closeModal} />
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/MembersGrid.jsx.erb